import XAdvertisement from "@/components/XAdvertisement";

const Index = () => {
  return (
    <XAdvertisement />
  );
};

export default Index;
